export const getReferencedFields = (questions) => { // Get the fields that are been watched for other fields in case of changes
  const referencedFields = [];

  questions.forEach((question) => {
    if(question.field.interactions)
      referencedFields.push(...question.field.interactions.map((interaction) => interaction.fieldId));
  });

  return [...new Set(referencedFields)];
};

// When a referenced field had some change this function is called
// then it handles the interactions if it matches the right value 
export const searchApplyInteractions = (lastFieldModified, questions, answers) => { 
  questions.forEach((question, index) => {
    if(question.field?.interactions && question.field.interactions.length > 0) {
      const interactions = question.field.interactions.filter((interaction) => interaction.fieldId === lastFieldModified.id) // extract the features that should be modified due to the interaction

      interactions.forEach((interaction) => {
        if(interaction.value && lastFieldModified.value === interaction.value) { // check if the value is the right one to make the changes
          switch (interaction.action) { // the actions is allowed to grow when is needed 
            case "toggle":
              if(interaction.feature === "required") // this validation is because the feature 'required' is outside the feature 'field'
                questions[index].required = !interaction.default;
              else
                questions[index].field[interaction.feature] = !interaction.default;
              break;
            default:
              break;
          }
        } else { // when the value is incorrect or the right value was changed the features previously changed need to be reseted
          if(interaction.feature === "required")
            questions[index].required = interaction.default;
          else {
            questions[index].field[interaction.feature] = interaction.default;

            if(interaction.feature === "display" && answers.length > 0) { 
              answers[index].value = "";
              answers[index].textValue = "";
            }
          }
        }
      })
    }
  })
};
